import Layout from "../components/layout/Layout";
import SEO, { breadcrumbSchema, orgSchema } from "../components/layout/SEO";
import Breadcrumbs from "../components/shared/Breadcrumbs";
import SectionHeading from "../components/home/SectionHeading";
import CaseReviewSection from "../components/home/CaseReviewSection";
import LangLink from "../components/shared/LangLink";
import { StaggerGroup, StaggerItem } from "../components/shared/Reveal";
import { ArrowUpRight } from "lucide-react";
import { SITE } from "../data/site";
import { useI18n } from "../i18n";

// Reusable hub-page layout: heading, intro, grid of child links, case-review.
export default function HubTemplate({ eyebrow, title, intro, path, items = [], breadcrumb }) {
  const { t, lang } = useI18n();
  return (
    <Layout>
      <SEO
        title={`${title} | ${SITE.name}`}
        description={intro}
        path={path}
        noindex={lang !== "en"}
        schema={[orgSchema(), breadcrumbSchema([{ name: "Home", to: "/" }, { name: title, to: path }])]}
      />
      <Breadcrumbs items={breadcrumb || [{ name: title }]} />

      <section className="container-psv py-12 md:py-20">
        <SectionHeading eyebrow={eyebrow} heading={title} intro={intro} />

        {items.length > 0 && (
          <StaggerGroup className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {items.map((item) => (
              <StaggerItem key={item.to}>
                <LangLink
                  to={item.to}
                  className="group flex items-center justify-between gap-3 bg-surface border border-border rounded-lg p-6 hover:border-accent transition-colors duration-300"
                  data-testid={`hub-link-${item.to.replace(/\//g, "")}`}
                >
                  <span className="font-serif text-xl text-primary leading-snug">{item.title}</span>
                  <ArrowUpRight className="w-5 h-5 text-accent opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all shrink-0" />
                </LangLink>
              </StaggerItem>
            ))}
          </StaggerGroup>
        )}
      </section>

      <CaseReviewSection />
    </Layout>
  );
}
